import React from 'react';
import cls from 'classnames';
import {Popover} from 'react-bootstrap';
import CopyInputToClipboard from './CopyInputToClipboard';

function ShareAgendaPopOver({entity, urlToShare, className, ...rest}) {
    const entityText = entity === 'Speaker' ? 'speaker' : 'session';
    return (
        <Popover id="agenda-share-pop-over" className={cls('agenda-share-pop-over', className)} {...rest}>
            <div className="header-share">Copy the URL to share this {entityText}'s page</div>
            <CopyInputToClipboard textToCopy={urlToShare} entityText={entityText}/>
        </Popover>
    );
}
export default ShareAgendaPopOver;
